import {createRouter, parseSearchWith, stringifySearchWith} from '@tanstack/react-router';

import {routeTree} from '~router/routeTree';

/**
 * Parse individual search param value
 * Handles: pipe-separated arrays, booleans, keeps strings (no number parsing)
 */
function customParseSearch(value: string): any {
  // Handle pipe-separated arrays
  if (value.includes('|')) {
    return value.split('|');
  }

  // Handle booleans
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }

  // Keep as string (don't parse numbers to avoid precision loss)
  return value;
}

/**
 * Stringify individual search param value
 * Handles arrays with pipe separator, converts other values to string
 */
function customStringifySearch(value: any): string {
  // Handle arrays - join with pipe separator
  if (Array.isArray(value)) {
    return value.join('|');
  }

  // Convert other values to string
  return String(value);
}

// Create the router instance
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  parseSearch: parseSearchWith(customParseSearch),
  stringifySearch: stringifySearchWith(customStringifySearch),
  defaultErrorComponent: ({error}) => {
    console.error('Router error:', error);
    return <div>Route Error: {error instanceof Error ? error.message : String(error)}</div>;
  },
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
